export const DESCRIPTION_MAX_LENGTH = 1000;
export const DEFAULT_MAX_ITEMS_PER_TRANSACTION = 50;
export const MULTIPLE_CHOICE_ADDON = 'multiple_choice';
export const SINGLE_CHOICE_ADDON = 'single_choice';
